export const actionNodeTypes = {
    dateFormat: 'dateFormat',
    decimalFormat: 'decimalFormat',
    displayList: 'displayList',
    isEmpty: 'isEmpty',
    remap: 'remap',
    math: 'math',
    isNull: 'isNull',
    redis: 'redis',
    regularExpression: 'regularExpression',
    httpCall: 'httpCall',
    encrypt: 'encrypt',
    setVariable: 'setVariable',
    waitForCallback: 'waitForCallback',
    chatHub: 'chatHub',
    sendTemplate: 'sendTemplate',
    switchCase: 'switchCase',
    customTransform: 'customTransform',
    optOut: 'optOut',
    verifyOptOut: 'verifyOptOut',
    deleteOptOut: 'deleteOptOut',
};

export const searchBarStates = {
    opened: 'opened',
    closed: 'closed'
};


export const showHttpResponseCodeTimeList: Array<String> = [
    'waitForCallback', 'httpCall', 'optOut', 'verifyOptOut', 'deleteOptOut'
];
